import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Title } from 'components/Checkout2/UI/Title';
import { DescriptionField2 } from 'components/UI';
import { FunctionComponent } from 'react';

interface NotesProps {
    notes: string;
    disabled?: boolean;
    onChange?: (notes: string) => void;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {},
        notesField: {
            'fontSize': 14,
            'lineHeight': '18px',
            'marginTop': 10,
            '& textarea': {
                height: '121px !important',
                fontSize: 14,
                padding: '23px 19px',
                [theme.breakpoints.up('md')]: {
                    padding: '23px 28px'
                }
            }
        }
    })
);

export const Notes: FunctionComponent<NotesProps> = props => {
    const classes = useStyles();

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Title title="Booking Notes" />
            <DescriptionField2
                name="notes"
                placeholder="Notes here..."
                label=""
                className={classes.notesField}
                value={props.notes}
                onChange={(value, name) => props.onChange && props.onChange(value)}
                maxRows={3}
                disabled={props.disabled}
            />
        </Box>
    );
};

export default Notes;
